import { render, staticRenderFns } from "./StudyProductCourseList.vue?vue&type=template&id=5cf704f4&"
import script from "./StudyProductCourseList.vue?vue&type=script&lang=js&"
export * from "./StudyProductCourseList.vue?vue&type=script&lang=js&"
import style0 from "./StudyProductCourseList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports